import React from 'react';
import './AvatarSkeleton.css';

interface AvatarSkeletonProps {
  size?: number;
}

const AvatarSkeleton: React.FC<AvatarSkeletonProps> = ({ size = 28 }) => {
  return (
    <div 
      className="avatar-skeleton" 
      style={{ width: `${size}px`, height: `${size}px` }}
    />
  );
};

export default AvatarSkeleton; 